import { IAppStore } from './store';
import { chatReducer } from '../../reducers/chat';
import { chatOnboardingReducer } from '../../reducers/chatOnboarding';
import { complainReducer } from '../../reducers/complain';
import { favoritesAssignReducer } from '../../reducers/favoritesAssign';
import { journalHighlightsReducer } from '../../reducers/journalHighlights';
import { mortgageDataReducer } from '../../reducers/mortgageData';
import { newbuildingBrokerCallbackWidgetReducer } from '../../reducers/newbuildingBrokerCallbackWidget';
import { newbuildingBrokerSelfRequestFormWidgetReducer } from '../../reducers/newbuildingBrokerSelfRequestFormWidget';
import { newbuildingInformationReducer } from '../../reducers/newbuildingInformation/reducer';
import { newbuildingLayoutDetailsModalReducer } from '../../reducers/newbuildingLayoutDetailsModal';
import { newbuildingLayoutOffersReducer } from '../../reducers/newbuildingLayoutOffers';
import { newbuildingLayoutsCountReducer } from '../../reducers/newbuildingLayoutsCount';
import { newbuildingLayoutsOnReducer } from '../../reducers/newbuildingLayoutsOn';
import { notAvailablePopupReducer } from '../../reducers/notAvailablePopup';
import { userReducer } from '../../reducers/user';
import { flatTourBookingReducer } from '../../serp/state/flatTourBooking';
import { hideOfferReducer } from '../../serp/state/hide_offer';
import { infoForTgbReducer } from '../../serp/state/infoForTgb/reducer/infoForTgbReducer';
import { showMotivationPopupReducer } from '../../serp/state/login_motivation_popup';
import { newbuildingInfoReducer } from '../../serp/state/newbuilding_info';
import { agentRatingReducer } from '../../serp/state/offer_card/agent';
import { offerCommentsReducer } from '../../serp/state/offer_card/comments';
import { offerComplaintsReducer } from '../../serp/state/offer_card/complaints';
import { complaintFeedbackReducer } from '../../serp/state/offer_card/feedback_complaint';
import { simplifiedOfferCardPopupsStateReducer } from '../../serp/state/offer_card/simplified_card_popups';
import { comparisonNotificationReducer, offerComparisonStatusReducer } from '../../serp/state/offersComparison';
import { offersPrintReducer } from '../../serp/state/print';
import { suggestionsDistancesReducer } from '../../serp/state/suggestions';
import { btpFlightRkActivityReducer } from 'shared/reducers/btpFlightRkActivity';
import { consultantCianChatReducer } from 'shared/reducers/consultantCianChat';
import { earlyAccessReducer } from 'shared/reducers/earlyAccess';
import { etazhiBlackFridayReducer } from 'shared/reducers/etazhiBlackFriday';
import { favoriteReducer } from 'shared/reducers/favorite';
import { paginationReducer } from 'shared/reducers/pagination';
import { randomBooleanReducer } from 'shared/reducers/randomBoolean';
import { searchReducer } from 'shared/reducers/search';

export function attachReducers(store: IAppStore) {
  store.addReducer(agentRatingReducer);
  store.addReducer(favoriteReducer);
  store.addReducer(newbuildingInfoReducer);
  store.addReducer(offerCommentsReducer);
  store.addReducer(offerComplaintsReducer);
  store.addReducer(offersPrintReducer);
  store.addReducer(paginationReducer);
  store.addReducer(searchReducer);
  store.addReducer(showMotivationPopupReducer);
  store.addReducer(simplifiedOfferCardPopupsStateReducer);
  store.addReducer(infoForTgbReducer);
  store.addReducer(suggestionsDistancesReducer);
  store.addReducer(hideOfferReducer);
  store.addReducer(complaintFeedbackReducer);
  store.addReducer(favoritesAssignReducer);
  store.addReducer(mortgageDataReducer);
  store.addReducer(chatReducer);
  store.addReducer(userReducer);
  store.addReducer(offerComparisonStatusReducer);
  store.addReducer(comparisonNotificationReducer);
  store.addReducer(flatTourBookingReducer);
  store.addReducer(newbuildingBrokerSelfRequestFormWidgetReducer);
  store.addReducer(newbuildingBrokerCallbackWidgetReducer);
  store.addReducer(newbuildingInformationReducer);
  store.addReducer(newbuildingLayoutDetailsModalReducer);
  store.addReducer(newbuildingLayoutsCountReducer);
  store.addReducer(newbuildingLayoutOffersReducer);
  store.addReducer(newbuildingLayoutsOnReducer);
  store.addReducer(notAvailablePopupReducer);
  store.addReducer(journalHighlightsReducer);
  store.addReducer(complainReducer);
  store.addReducer(chatOnboardingReducer);
  store.addReducer(consultantCianChatReducer);
  store.addReducer(btpFlightRkActivityReducer);
  store.addReducer(randomBooleanReducer);
  store.addReducer(earlyAccessReducer);

  /**
   * Код появился к проекту "Чёрная пятница" для компании "Этажи".
   * @todo: удалить в задаче CD-250843
   */
  store.addReducer(etazhiBlackFridayReducer);
}
